import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sites';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-gamepad-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg text-background-50">
                Galgame资源导航
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              精心汇总主流galgame资源网站，涵盖免费下载、汉化补丁、攻略合集与最新资源更新，帮助玩家告别资源荒。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-100 mb-4">
              资源分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-100 mb-4">
              推荐文章
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/article/2024-best-galgame-sites"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  2024 galgame资源网站推荐
                </Link>
              </li>
              <li>
                <Link
                  to="/article/galgame-chinese-patch-guide"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  galgame汉化完全指南
                </Link>
              </li>
              <li>
                <Link
                  to="/article/top-10-galgame-recommendations-2024"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  2024必玩galgame推荐
                </Link>
              </li>
              <li>
                <Link
                  to="/article/galgame-installation-troubleshooting"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  安装问题解决方案
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-100 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  用户评价
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-300/20 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; {currentYear} Galgame资源导航. 本站为资源导航类网站，不直接提供游戏文件下载。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/20 hover:bg-primary-500/30 transition-colors"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-sm text-background-300"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/20 hover:bg-primary-500/30 transition-colors"
              rel="nofollow"
            >
              <i className="ri-bilibili-line text-sm text-background-300"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300/20 hover:bg-primary-500/30 transition-colors"
              rel="nofollow"
            >
              <i className="ri-discord-line text-sm text-background-300"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}